/**
 **@author       yontaek@zumper.com (Yon Taek Chung)
 **@copyright    Copyright (c) 2024, Zumper
 */

import comprehensiveListingsIcon from './svg/comprehensiveListings.svg'
import peaceOfMindIcon from './svg/peaceOfMind.svg'
import usefulResourcesIcon from './svg/usefulResources.svg'

export const RENTING_MADE_EASY_CONTENTS = [
  {
    text: 'Comprehensive listings',
    subText:
      'Browse and apply to over 1 million listings with long or short term leases throughout the U.S. and Canada.',
    icon: comprehensiveListingsIcon,
  },
  {
    text: 'Useful resources',
    subText:
      'Make informed decisions with our rent trends, city guides, affordability calculator, and Zumper Expert Ratings.',
    icon: usefulResourcesIcon,
  },
  {
    text: 'Peace of mind',
    subText:
      "Feel secure on your rental journey, knowing we're committed to accuracy and providing verified listings.",
    icon: peaceOfMindIcon,
  },
]
